import { camelToSnakeCase } from "common/utils/helpers/cases";

export const deepFlattenObject = (
  obj: Record<string, unknown>,
  keyNameDelimiter = "_",
  prefix = ""
): Record<string, unknown> => {
  const flattened: Record<string, unknown> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const snakeKey = camelToSnakeCase(key);
      const newKey = prefix ? `${prefix}${keyNameDelimiter}${snakeKey}` : snakeKey;
      const value = obj[key];

      if (value !== null && typeof value === "object") {
        if (Array.isArray(value)) {
          // Handle arrays by using indices
          value.forEach((item, index) => {
            const arrayKey = `${newKey}${keyNameDelimiter}${index}`;
            if (item !== null && typeof item === "object") {
              // Assumes plain JSON objects (no class instances, Maps, Sets, etc.)
              Object.assign(
                flattened,
                deepFlattenObject(item as Record<string, unknown>, keyNameDelimiter, arrayKey)
              );
            } else {
              flattened[arrayKey] = item;
            }
          });
        } else {
          // Handle nested objects
          Object.assign(
            flattened,
            deepFlattenObject(value as Record<string, unknown>, keyNameDelimiter, newKey)
          );
        }
      } else {
        flattened[newKey] = value;
      }
    }
  }

  return flattened;
};
